import React, { Component } from 'react';
import { connect } from 'react-redux';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { Link } from "react-router-dom";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { getUsers,
  switchSelectedTab,
  setUsersTab,
  resetPaginationToNull
} from '../actions/userActions';
import { userStyles } from '../styles';
import {
  WithStyles,
  Grid,
  withStyles,
  Paper,
  Button
} from '@material-ui/core';
import UserTable from './UserTable';
import MyPATNoDataPanel from '../../common/MyPATNoDataPanel';
import { toggleLicenseExpiredDialog } from "../../login/actions/userActions";
import { withRouter } from 'react-router-dom';
interface UserListingProps extends WithStyles<typeof userStyles> {
  getUsers: any;
  usersData: any;
  totalPages: number;
  loggedInUserData: any;
  showLicenseExpiredDialog: any;
  isPostExpiryDays: any;
  toggleLicenseExpiredDialog: any;
  usersSearch: any;
  pageNumber: number;
  history: any;
  switchSelectedTab: Function,
  setUsersTab: Function,
  usersSearchData: any,
  resetPaginationToNull: Function
}

class UserListing extends Component<UserListingProps> {
  state = {
    currentPage: 1,
    previousPages: [],
    nextPages: [2, 3, 4, 5],
    lastPage: null,
    paginationElements: null
  };

  componentDidMount() {
    this.setCurrentPage(1);
    this.setState({
      paginationElements: this.generatePaginationElements()
    })
  }
  constructor(props: UserListingProps) {
    super(props);
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if(prevProps.usersData !== this.props.usersData){
      this.setState({
        paginationElements: this.generatePaginationElements()
      })
    }
    if(prevProps.pageNumber !== this.props.pageNumber){
      this.props.history.push("/userManagement");
      this.props.switchSelectedTab("Users");
      this.props.setUsersTab(true);
      this.props.resetPaginationToNull();
    }

    if(prevProps.totalPages !== this.props.totalPages){
      this.setCurrentPage(1);
    }

  }

  componentWillUnmount(){
    this.props.getUsers({pageNumber: 1});
  }

  setCurrentPage = (pageNumber: any) => {
    const currentPage = pageNumber;
    this.props.getUsers({pageNumber: pageNumber, usersSearch: this.props.usersSearchData});
    const prevPages = this.setPrevPages(currentPage);
    const nextPages = this.setNextPages(currentPage);
    this.setState({
      currentPage: currentPage,
      previousPages: prevPages,
      nextPages: nextPages,
      lastPage: this.props.totalPages,
    });
  };

  setPrevPages = (currentPage: any) => {
    let previousPages: any = [];

    switch (currentPage) {
      case 1:
        previousPages = [];
        break;
      case currentPage:
        let maxPreviousPages = 2;
        while (currentPage !== 1 && maxPreviousPages !== 0) {
          currentPage = currentPage - 1;
          previousPages.push(currentPage);
          maxPreviousPages -= 1;
        }
        let index = previousPages.indexOf(1);
        if (index > -1) {
          previousPages.splice(index, 1);
        }
        break;
      default:
        previousPages = [];
    }

    return previousPages;
  };

  setNextPages = (currentPage: any) => {
    let nextPages: any = [];

    switch (currentPage) {
      case 1:
        if (this.props.totalPages > 5) {
          nextPages = [2, 3, 4, 5];
        } else {
          for (let i = 2; i < this.props.totalPages; i++) {
            nextPages.push(i);
          }
        }
        break;
      case currentPage:
        let maxNextPages = 2;
        while (
          currentPage !== this.props.totalPages &&
          maxNextPages !== 0
        ) {
          currentPage = currentPage + 1;
          nextPages.push(currentPage);
          maxNextPages -= 1;
        }
        let index = nextPages.indexOf(this.props.totalPages);
        if (index > -1) {
          nextPages.splice(index, 1);
        }
        break;
      default:
        nextPages = [2, 3, 4, 5];
    }
    return nextPages;
  };

  nextPage = (currentPage: any) => {
    let nextPage = currentPage + 1;
    if (nextPage <= this.props.totalPages) {
      this.setCurrentPage(nextPage);
    }
  };

  prevPage = (currentPage: any) => {
    let prevPage = currentPage - 1;
    if (prevPage !== 0) {
      this.setCurrentPage(prevPage);
    }
  };

  generatePaginationElements = () => {
    const { classes } = this.props;
    // Add UI
    let firstPage = (
      <Grid
        onClick={() => {
          this.setCurrentPage(1);
        }}
      >
        {1}
      </Grid>
    );
    let currentPage = (
      <Grid
        onClick={() => {
          this.setCurrentPage(this.state.currentPage);
        }}
      >
        {this.state.currentPage}
      </Grid>
    );
    let morePages = <Grid onClick={() => {}}>...</Grid>;
    let previousPages = this.state.previousPages.map((page, index) => {
      return (
        <Grid
          key={index}
          onClick={() => {
            this.setCurrentPage(page);
          }}
        >
          {page}
        </Grid>
      );
    });
    previousPages = previousPages.reverse();
    let nextPages = this.state.nextPages.map((page, index) => {
      return (
        <Grid
          key={index}
          onClick={() => {
            this.setCurrentPage(page);
          }}
        >
          {page}
        </Grid>
      );
    });
    let lastPage = (
      <Grid
        onClick={() => {
          this.setCurrentPage(this.props.totalPages);
        }}
      >
        {this.props.totalPages}
      </Grid>
    );

    return (
      <span className={classes.numberContainer} >
        {this.props.totalPages > 1 && <span onClick={() => this.prevPage(this.state.currentPage)} className={`${this.state.currentPage === 1 ? classes.disablePointer : classes.arrowIcons}`}>
          <ArrowBackIosIcon />
        </span>}
        {this.state.currentPage !== 1 ? firstPage : null}
        {this.state.currentPage !== 1 &&
          this.state.currentPage > 4 &&
         !previousPages.includes(firstPage) &&
         this.props.totalPages > 4
          ? morePages
          : null}
        {this.props.totalPages >= 4 && previousPages}
        {this.props.totalPages !== 1 && currentPage}
        {this.props.totalPages >= 2 && nextPages}
        {this.state.currentPage !== this.state.lastPage &&
        !nextPages.includes(lastPage) &&
        this.props.totalPages > 4
          ? morePages
          : null}
        {this.state.currentPage !== this.state.lastPage &&
          this.props.totalPages !== 1 && 
          this.props.totalPages >= 2
        ? lastPage : null}
        {this.props.totalPages > 1 && <span onClick={() => this.nextPage(this.state.currentPage)} className={`${this.state.currentPage === this.state.lastPage ? classes.disablePointer : classes.arrowIcons}`}>
          <ArrowForwardIosIcon />
        </span>}
      </span>
    );
  };

  render() {
    const { classes } = this.props;
    let headers: any, data, action;
    
    // const paginationElements = this.generatePaginationElements();

    headers = ['S.No','Emp Code','Email','Client', 'Name', 'Role', 'Status', 'Action'];
    data = this.props.usersData ? this.props.usersData : null;
    action = {
      isEdit: true,
      editURL: '/userManagement/editUser/',
    };
    console.log('User Data', this.props.usersData)
    console.log('User Data Length', this.props.usersData && this.props.usersData.length)

    return (
      <>
        <Paper className={classes.customPaper}>
          <div className={classes.tableWrapper}>
            {this.props.usersData && this.props.usersData !== null && this.props.usersData.length !== 0 && (
              <UserTable
                currentPage = {this.state.currentPage}
                headers={headers}
                data={data}
                action={action}
              />
            )}
             {!this.props.usersData && (
                <MyPATNoDataPanel
                  imageURL="/assets/svg/userManagement/noRollData.svg"
                  heading="No Users added"
                  htmlElement={
                    <>
                      <Link
                        to="/userManagement/addUser"
                        style={{ textDecoration: "none" }}
                      >
                        { this.props.usersSearch === null && <Button
                          variant="contained"
                          className={classes.btnCreateGoal}
                          color="primary"
                        >
                          Add User
                        </Button>}
                      </Link>
                    </>
                  }
                  subPara="You can view the  list of users created by you in this tab. No user have been added so far, click on ‘Add User’ to add a new author in your organization."
                />
              )}
               {(this.props.usersData && this.props.usersData.length === 0) && (
                <MyPATNoDataPanel
                  imageURL="/assets/svg/userManagement/noRollData.svg"
                  heading="No Users"
                />
              )}
          </div>
        </Paper>
        {this.props.usersData && this.props.usersData !== null && this.props.usersData.length !== 0 && this.props.totalPages > 1 && (
        <Grid container justify="flex-end" alignItems="center">
          <Grid item>
            <Grid className={classes.numberContainer}>
              {this.state.paginationElements}
            </Grid>
          </Grid>
        </Grid>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  usersData: state.clientManagement.usersManagement.usersData,
  totalPages: state.clientManagement.usersManagement.totalPages,
  loggedInUserData:
  state.loginData.userData &&
  state.loginData.userData.loggedInUserData,
  showLicenseExpiredDialog:
  state.loginData.userData &&
  state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:
  state.loginData.userData &&
  state.loginData.userData.isPostExpiryDays,
  usersSearch: state.clientManagement.usersManagement.usersSearch,
  pageNumber:  
  state.clientManagement.rolesManagement && 
  state.clientManagement.rolesManagement.pageNumber,
  usersSearchData: state.clientManagement.usersManagement.usersSearchData,
});

const mapDispatchToProps = {
  getUsers,
  toggleLicenseExpiredDialog,
  switchSelectedTab,
  setUsersTab,
  resetPaginationToNull
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(withRouter(UserListing)));
